// import axiosInstance from "../../../axios";
// import config from "../../../config";
// import { usePersistedStore } from "../../persisted-store";

// export const createRequestReportSlice = (set, get) => ({
//     crmRequestReport: {
//         loading: false,
//         data: []
//     },
//     getCrmRequestReport: async (UsrUserID) => {
//         const token = usePersistedStore.getState().business.currentBusiness.token;
//         set(state => ({ crmRequestReport: { ...state.crmRequestReport, loading: true } }));
//         try {
//             const resp = await axiosInstance({
//                 method: 'get',
//                 baseURL: config.apiUrls(),
//                 url: `v1/crm/request-report/user/${UsrUserID}`,
//                 headers: { token }
//             });
//             set(state => ({ crmRequestReport: { loading: false, data: resp.data } }));
//         } catch (error) {
//             set(state => ({ crmRequestReport: { ...state.crmRequestReport, loading: false } }));
//         }
//     }
// });
import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

let crmRequestReportRequestId = 0;

export const createRequestReportSlice = (set, get) => ({
    crmRequestReport: {
        loading: false,
        data: []
    },
    getCrmRequestReport: async (params) => {
        const requestId = ++crmRequestReportRequestId;
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ crmRequestReport: { ...state.crmRequestReport, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'post',
                baseURL: config.apiUrls(),
                url: `v1/crm/user/${params.usrUserID}/insurance`,
                headers: { token },
                data: {
                    PageNumber: params.PageNumber,
                    PageSize: params.PageSize,
                    CategoryPaymentStatus: params.CategoryPaymentStatus,
                    ...(params.InsuranceRequestId ? { InsuranceRequestId: params.InsuranceRequestId } : {}),
                    ...(params.TrackingCode ? { TrackingCode: params.TrackingCode } : {})
                },
            });
            if (requestId !== crmRequestReportRequestId) return;
            set(state => ({ crmRequestReport: { loading: false, data: resp.data } }));
        } catch (error) {
            if (requestId !== crmRequestReportRequestId) return;
            set(state => ({ crmRequestReport: { data: [], loading: false } }));
        }
    }
});